import type { ReactNode } from 'react'
import { Badge } from '../badge'
import { Button } from '../button'

interface ReassignmentCardBaseProps {
  title: string
  subtitle: string
  badge?: { label: string; color: 'mint' | 'gold' }
  actionButton?: { label: string; onClick: () => void }
  secondaryActionButton?: { label: string; onClick: () => void }
  onViewDetailsClick?: () => void
  children?: ReactNode
}

export function ReassignmentCardBase({
  title,
  subtitle,
  badge,
  actionButton,
  secondaryActionButton,
  onViewDetailsClick,
  children,
}: ReassignmentCardBaseProps) {
  return (
    <div className="bg-sand border border-sand-dark rounded-lg p-4 shadow">
      {/* Header: icon + text on left, action button on right */}
      <div className="flex items-start justify-between gap-4">
        <div className="flex gap-2 flex-1">
          <i
            className="fa-sharp fa-solid fa-arrows-turn-to-dots text-orange mt-1"
            aria-hidden="true"
          />
          <div className="flex-1">
            <p className="font-semibold text-charcoal">{title}</p>
            <p className="text-charcoal-50">{subtitle}</p>
            {onViewDetailsClick && (
              <button
                type="button"
                onClick={onViewDetailsClick}
                className="text-indigo underline hover:text-indigo-dark cursor-pointer bg-transparent border-0 p-0 font-medium mt-1"
              >
                View Details
              </button>
            )}
          </div>
        </div>

        <div className="flex items-center gap-2">
          {/* Status badge */}
          {badge && <Badge label={badge.label} color={badge.color} />}
          {/* Action button */}
          {actionButton && (
            <Button variant="primary" onClick={actionButton.onClick}>
              {actionButton.label}
            </Button>
          )}
          {/* Secondary action button */}
          {secondaryActionButton && (
            <Button variant="secondary" onClick={secondaryActionButton.onClick}>
              {secondaryActionButton.label}
            </Button>
          )}
        </div>
      </div>

      {/* Optional children content */}
      {children}
    </div>
  )
}
